import { render } from "./VehicleDeviceMapping.vue?vue&type=template&id=0f411d63&scoped=true"
import script from "./VehicleDeviceMapping.vue?vue&type=script&lang=js"
export * from "./VehicleDeviceMapping.vue?vue&type=script&lang=js"

import "./VehicleDeviceMapping.vue?vue&type=style&index=0&id=0f411d63&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MSRTC\\MSRTC-CODE\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f411d63"]])

export default __exports__